// SESSION
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const SETTINGS = 'SETTINGS';
export const TOGGLE_LOCALE = 'TOGGLE_LOCALE';
export const SAVE_SETTINGS = 'SAVE_SETTINGS';
export const SET_COLOR = 'SET_COLOR';
export const LOAD_QR_TELEGRAM = 'LOAD_QR_TELEGRAM';
export const ACTIVATE_CHANGE_PASSWORD = 'ACTIVATE_CHANGE_PASSWORD';
export const RESET_STATS = 'RESET_STATS';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const SNACKBAR = 'SNACKBAR';
export const SET_SHOWCODES = 'SET_SHOWCODES';
export const SET_SHOWCONCORDATI = 'SET_SHOWCONCORDATI';
export const SET_MODALITA_ESTESA = 'SET_MODALITA_ESTESA';
export const CLEAR_USER_PREF = 'CLEAR_USER_PREF';
// HOME
export const HOME_CARDS = 'HOME_CARDS';
export const TOTALE_MENSILE = 'TOTALE_MENSILE';
export const NUOVI_CLIENTI = 'NUOVI_CLIENTI';
export const TOP_ARTICOLI_OGGI = 'TOP_ARTICOLI_OGGI';
// CALENDAR
export const CALENDAR_SET = 'CALENDAR_SET';
export const CALENDAR_CHIUSURE = 'CALENDAR_CHIUSURE';
// DATATABLES
export const DATATABLE = 'DATATABLE';
export const LOAD_FILTERS = 'LOAD_FILTERS';
export const LOAD_MORE = 'LOAD_MORE';
export const FILTER_SEARCH = 'FILTER_SEARCH';
export const ROW_DETAIL = 'ROW_DETAIL';
export const ROW_DETAIL_COMANDA = 'ROW_DETAIL_COMANDA';
export const VARIANTI_ARTICOLO = 'VARIANTI_ARTICOLO';
// GRAFICI
export const GRAFICO_CONTI = 'GRAFICO_CONTI';
export const TORTA_TAVOLI = 'TORTA_TAVOLI';
export const TORTA_SALE = 'TORTA_SALE';
export const VENDUTO_SU_ORDINATO = 'VENDUTO_SU_ORDINATO';
export const CORRISPETTIVI = 'CORRISPETTIVI';
export const TOP_ARTICOLI = 'TOP_ARTICOLI';
export const DIFF_VENDUTO_ORDINATO = 'DIFF_VENDUTO_ORDINATO';
// EXTRA
export const ESPORTA_CORRISPETTIVI = 'ESPORTA_CORRISPETTIVI';
